<hpf-route-form
        *ngIf="route"
        [route]="route"
        (create)="onCreate($event)"
    ></hpf-route-form>
<div *ngIf="!route" class="my-5 text-center">
    <nz-spin nzSimple></nz-spin>
</div>